export default class Module {
	constructor(app) {
		this.app = app;
	}

	init() {
		
	}
}
